import { Theme, ThemeConsumer } from '@rneui/themed';
import React, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import CustomerModal from '../../sellscreenCheckout/addCustomer';
import { ZenLoader, ZenText } from 'zen-core-elements';
import CommonService from '../../../../shared/services/commonService';
import OrderSuccessModal from './orderSucessModal';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useAppNavigation } from '../../../../types/@react-navigation/navigation';
import { reFundAndRePay, onCompleteSale } from '../../../../redux/slices/newSellscreenPaymentSlice';
import { resetSale } from '../../../../redux/slices/newSellscreenSlice';
import { CustomModal } from '../../../../shared/commonComponents/customModal';
import moment from 'moment';
import LottieView from 'lottie-react-native';


const PaymentCompleted = () => {
	const navigation = useAppNavigation()
	const dispatch = useAppDispatch()
	const { isRepaymentEnabled, paidAmount, totalAmount, transactionData, remainingAmount, placeOrderApi: { success, loader } } = useAppSelector((state) => state.NewSellscreenPaymentSlice)
	const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'
	const method = transactionData?.[0]?._paymentMethod
	const changeDue = paidAmount - totalAmount;

	const isSplitPayment = transactionData?.length > 1

	const onSwitch = () => {
		dispatch(reFundAndRePay())
	}

	const onCompleteSaleFn = () => {
		dispatch(onCompleteSale());
		dispatch(resetSale());
		navigation?.goBack();
	}

	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<ScrollView >
						<View style={{ flex: 1 }}>
							<View style={styles.topHeader}>
								<CustomerModal isPaymentScreen disabled />
								{/* {isRepaymentEnabled ? */}
								<TouchableOpacity style={styles.secondaryBtn} onPress={onSwitch}>
									<ZenText content={"Refund & Re-Pay"} style={styles.secondaryBtnText} />
								</TouchableOpacity>
								{/* :<></>} */}
							</View>

							<View style={styles.safeArea}>
								<View style={styles.container}>

									{/* 1. Header Status */}
									<View style={styles.header}>
										{/* <View style={styles.iconCircle}>
											<ZenText content="✓" style={styles.checkIcon} />
										</View> */}
										{/* <LottieView source={require("../../../../assets/Wallet Animation.json")}
											autoPlay
											loop={false}
											style={{
												height: 200,
												width: 250,
												backgroundColor: "transparent",
											}} /> */}
										<ZenText content={isSplitPayment ? "Split Payment" : method + " Payment"} style={styles.statusTitle} />
										<ZenText content={moment(new Date())?.format("MMM DD, YYYY • hh:mm A")} style={styles.timestamp} />
									</View>

									{/* 2. Main "Change" Display (Only if Cash & more was paid) */}
									{changeDue > 0 ? (
										<View style={styles.changeHero}>
											<ZenText content="GIVE CHANGE" style={styles.changeLabel} />
											<ZenText content={CommonService?.currencyStandard(currencySymbol, changeDue?.toString())} style={styles.changeValue} />
										</View>
									) : (
										<View style={styles.noChangeHero}>
											<ZenText content="No Change Due" style={styles.noChangeText} />
										</View>
									)}

									{/* 3. Transaction Breakdown Table */}
									<View style={styles.summaryTable}>
										<ZenText content="Transaction Summary" style={styles.tableTitle} />

										<View style={styles.row}>
											<ZenText content="Total Bill" style={styles.rowLabel} />
											<ZenText content={CommonService?.currencyStandard(currencySymbol, totalAmount?.toString())} style={styles.rowValue} />
										</View>

										<View style={styles.row}>
											<ZenText content={`Amount Paid (${isSplitPayment ? "Split Payment" : method})`} style={styles.rowLabel} />
											<ZenText content={CommonService?.currencyStandard(currencySymbol, paidAmount?.toString())} style={[styles.rowValue, { color: theme?.tealGreen }]} />
										</View>

										{
											isSplitPayment ? transactionData?.map((payment, index) => (
												<View style={styles.row} key={index}>
													<ZenText content={"Payment" + " " + (index + 1) + " (" + payment?._paymentMethod + ")"} style={styles.rowLabel} />
													<ZenText content={CommonService?.currencyStandard(currencySymbol, payment?._paidAmount?.toString() || "")} style={[styles.rowValue, { color: theme?.tealGreen }]} />
												</View>
											)) : null
										}

										<View style={styles.divider} />

										<View style={styles.row}>
											<ZenText content="Balance Remaining" style={styles.totalLabel} />
											<ZenText content={CommonService?.currencyStandard(currencySymbol, remainingAmount?.toString() || "")} style={styles.totalValue} />
										</View>
									</View>

								</View>
							</View>
						</View>

						<OrderSuccessModal isVisible={success} onCompleteSale={onCompleteSaleFn} />
						<CustomModal visible={loader} transparent >
							<ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={theme?.primary} lottieType="Local" lottie={require('../../../../assets/infinityLoader.json')} />
						</CustomModal>
					</ScrollView>
				)
			}}
		</ThemeConsumer>
	);
};

const style = (theme: Theme) => StyleSheet.create({
	topHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, marginHorizontal: 10 },
	safeArea: { flex: 1, backgroundColor: theme?.iceWhite },
	container: { flex: 1, padding: 24 },

	header: { alignItems: 'center', marginTop: 20 },
	iconCircle: { width: 64, height: 64, borderRadius: 32, backgroundColor: theme?.wildGreen, justifyContent: 'center', alignItems: 'center', marginBottom: 16 },
	checkIcon: { color: theme?.light, fontSize: 32, fontFamily: theme?.bold },
	statusTitle: { fontSize: theme?.headerFontSize, fontFamily: theme?.bold, color: theme?.lightDark },
	timestamp: { color: theme?.grey, fontSize: theme?.errorFontSize, fontFamily: theme?.medium, marginTop: 4 },

	changeHero: { backgroundColor: theme?.light, padding: 15, borderRadius: 20, alignItems: 'center', marginVertical: 30, borderWidth: 1, borderColor: theme?.coolGray, elevation: 2 },
	changeLabel: { fontSize: theme?.miniFontSize, fontFamily: theme?.bold, color: theme?.lightDark, letterSpacing: 1.2 },
	changeValue: { fontSize: theme?.bigFontSize + 5, fontFamily: theme?.bold, color: theme?.primary },

	noChangeHero: { padding: 20, alignItems: 'center' },
	noChangeText: { color: theme?.grey, fontSize: theme?.errorFontSize, fontFamily: theme?.medium },

	summaryTable: { backgroundColor: theme?.light, padding: 20, borderRadius: 16, flex: 1 },
	tableTitle: { fontSize: theme?.smallerFontSize, fontFamily: theme?.bold, color: theme?.lightDark, marginBottom: 20 },
	row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 16 },
	rowLabel: { fontSize: theme?.smallerFontSize, fontFamily: theme?.medium, color: theme?.lightDark },
	rowValue: { fontSize: theme?.smallerFontSize, fontFamily: theme?.bold, color: theme?.primary },
	divider: { height: 1, backgroundColor: theme?.softSlate, marginVertical: 8 },
	totalLabel: { fontSize: theme?.smallerFontSize, fontFamily: theme?.medium, color: theme?.lightDark },
	totalValue: { fontSize: theme?.smallerFontSize, fontFamily: theme?.bold, color: theme?.lightDark },

	secondaryBtn: { borderRadius: 15, paddingVertical: 10, paddingHorizontal: 20, borderWidth: 1, borderColor: theme?.primary, backgroundColor: theme?.light },
	secondaryBtnText: { color: theme?.primary, fontSize: theme?.errorFontSize, fontFamily: theme?.bold },
});

export default PaymentCompleted;